var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
function createElement(as = 'div', _a, children) {
    var { className, testId, innerRef, dangerouslySetStyle } = _a, rest = __rest(_a, ["className", "testId", "innerRef", "dangerouslySetStyle"]);
    return React.createElement(as, Object.assign({ 'data-testid': testId, className, style: dangerouslySetStyle, ref: innerRef }, rest), children);
}
function withRef(Component) {
    return React.forwardRef((props, ref) => (
    /* eslint-disable react/jsx-props-no-spreading */
    React.createElement(Component, Object.assign({}, props, { innerRef: ref }))
    /* eslint-enable react/jsx-props-no-spreading */
    ));
}
export default {
    withRef,
    createElement,
};
//# sourceMappingURL=depot.js.map